const formatWon = (value) => {
  const number = Number(value);
  return Number.isFinite(number) ? `${Math.floor(number).toLocaleString('ko-KR')}원` : null;
};

const formatOdds = (value) => {
  const number = Number(value);
  return Number.isFinite(number) ? `${number.toFixed(2)}배` : null;
};

const pickPayload = (source) => {
  if (!source) return {};
  if (typeof source === 'string') return { message: source };
  if (source.response?.data) return source.response.data;
  return source;
};

const pickDetails = (payload = {}) => {
  const nested = payload.data && typeof payload.data === 'object' ? payload.data : {};
  return nested.details || payload.details || {};
};

export const getSportsnewBetErrorCode = (source) => {
  const payload = pickPayload(source);
  const nested = payload.data && typeof payload.data === 'object' ? payload.data : {};
  const code = [
    nested.code,
    payload.code,
    nested.rejectionReason,
    nested.rejection_reason,
    payload.rejectionReason,
    payload.rejection_reason,
    nested.voidReason,
    nested.void_reason,
    payload.voidReason,
    payload.void_reason,
  ].find((value) => typeof value === 'string' && /^[A-Z][A-Z0-9_]+$/i.test(value.trim()));
  return code ? code.trim().toUpperCase() : '';
};

const pickCode = (payload = {}) => {
  return getSportsnewBetErrorCode(payload) || payload.error || payload.message;
};

const pickMessageKo = (payload = {}) => {
  const nested = payload.data && typeof payload.data === 'object' ? payload.data : {};
  return nested.messageKo || payload.messageKo;
};

const rawMessageAllowed = (message) => {
  const text = String(message || '').trim();
  if (!text || text === 'Error in  response' || text === 'Error in response') return false;
  return !/^[A-Z0-9_]+$/.test(text);
};

const messageForCode = (code, details = {}) => {
  switch (String(code || '').trim().toUpperCase()) {
    case 'INVALID_USER':
      return '회원 정보를 확인할 수 없습니다. 다시 로그인해주세요.';
    case 'INVALID_IDEMPOTENCY_KEY':
      return '베팅 요청 정보가 올바르지 않습니다. 다시 시도해주세요.';
    case 'BETTING_DISABLED':
      return '현재 베팅이 허용되지 않습니다.';
    case 'INVALID_BET_MODE':
      return '베팅 구분이 올바르지 않습니다.';
    case 'INVALID_STAKE':
      return '베팅 금액이 올바르지 않습니다.';
    case 'INVALID_SELECTION_COUNT':
      return '선택지 수가 올바르지 않습니다.';
    case 'INVALID_SELECTION_REFERENCE':
    case 'DUPLICATE_SELECTION':
      return '선택지 정보가 올바르지 않습니다.';
    case 'INVALID_EXPECTED_PRICE':
      return '배당 정보가 올바르지 않습니다.';
    case 'MISSING_SELECTION_IDENTITY':
      return '선택지 정보가 최신 상태가 아닙니다. 새로고침 후 다시 선택해주세요.';
    case 'USER_WALLET_NOT_FOUND':
      return '지갑 정보를 찾을 수 없습니다.';
    case 'USER_NOT_ACTIVE':
      return '현재 베팅이 제한된 회원입니다.';
    case 'INSUFFICIENT_BALANCE':
      return '보유금이 부족합니다.';
    case 'IDEMPOTENCY_CONFLICT':
      return '이미 처리 중인 베팅 요청입니다. 잠시 후 다시 시도해주세요.';
    case 'IDEMPOTENCY_REPLAY_RETIRED':
      return '이전 베팅 요청은 이미 종료되었습니다. 베팅 내역을 확인한 뒤 다시 베팅해주세요.';
    case 'IDEMPOTENCY_REPLAY_STATUS_UNKNOWN':
      return '이전 베팅 처리 상태를 확인할 수 없습니다. 베팅 내역을 확인하거나 고객센터에 문의해주세요.';
    case 'SPORTSNEW_SECURE_IDEMPOTENCY_UNAVAILABLE':
    case 'SPORTSNEW_COMMAND_FINGERPRINT_UNAVAILABLE':
      return '안전한 베팅 요청 정보를 만들 수 없습니다. 브라우저를 새로고침한 뒤 다시 시도해주세요.';
    case 'SPORTSNEW_PLACEMENT_ATTEMPT_PERSISTENCE_UNAVAILABLE':
      return '베팅 요청 상태를 안전하게 저장할 수 없습니다. 브라우저 설정을 확인한 뒤 다시 시도해주세요.';
    case 'SPORTSNEW_PLACEMENT_ATTEMPT_UNRESOLVED':
      return '이전 베팅 요청의 처리 결과가 확인되지 않았습니다. 베팅 내역을 확인한 뒤 다시 시도해주세요.';
    case 'SELECTION_UNAVAILABLE':
      return '선택한 배당을 더 이상 이용할 수 없습니다.';
    case 'SELECTION_MODE_MISMATCH':
      return '선택한 배당의 경기 구분이 변경되었습니다.';
    case 'FIXTURE_UNAVAILABLE':
      return '해당 경기는 베팅할 수 없는 상태입니다.';
    case 'FIXTURE_STARTED':
      return '경기 시작 전 마감 시간이 지나 베팅할 수 없습니다.';
    case 'FIXTURE_STALE':
      return '경기 상태 확인이 지연되어 베팅할 수 없습니다.';
    case 'MARKET_UNAVAILABLE':
      return details.reason === 'LINE_WINDOW_LIMIT'
        ? '표시 가능한 기준점이 변경되어 베팅할 수 없습니다.'
        : '해당 마켓 또는 선택지가 잠겨 베팅할 수 없습니다.';
    case 'ODDS_STALE':
      return '배당 확인이 지연되어 베팅할 수 없습니다.';
    case 'ODDS_CHANGED':
      return details.currentPriceDecimal
        ? `배당이 ${formatOdds(details.currentPriceDecimal)}로 변경되었습니다.`
        : '배당이 변경되었습니다. 변경된 배당을 확인해주세요.';
    case 'STAKE_BELOW_MIN':
      return details.minStake ? `최소 베팅금액은 ${formatWon(details.minStake)}입니다.` : '최소 베팅금액보다 낮습니다.';
    case 'STAKE_ABOVE_MAX':
      return details.maxStake ? `최대 베팅금액은 ${formatWon(details.maxStake)}입니다.` : '최대 베팅금액을 초과했습니다.';
    case 'DAILY_STAKE_LIMIT':
      return details.maxDailyStake ? `일일 베팅한도는 ${formatWon(details.maxDailyStake)}입니다.` : '일일 베팅한도를 초과했습니다.';
    case 'OPEN_BET_LIMIT':
      return details.maxOpenBets ? `진행 중 베팅은 최대 ${details.maxOpenBets}건까지 가능합니다.` : '진행 중 베팅 한도를 초과했습니다.';
    case 'PROVIDER_STAKE_LIMIT':
      return details.maxStake ? `해당 배당의 최대 베팅금액은 ${formatWon(details.maxStake)}입니다.` : '해당 배당의 베팅한도를 초과했습니다.';
    case 'MARKET_DISABLED':
    case 'MARKET_DISABLED_FOR_SCOPE':
      return '해당 마켓은 현재 베팅할 수 없습니다.';
    case 'SAME_MARKET_OPPOSITE_NOT_ALLOWED':
      return '같은 경기 같은 마켓의 반대 선택지는 추가 베팅할 수 없습니다.';
    case 'SELECTION_COUNT_BELOW_MIN':
      return details.minSelections ? `최소 ${details.minSelections}폴더부터 베팅할 수 있습니다.` : '선택지 수가 최소 폴더수보다 적습니다.';
    case 'SELECTION_COUNT_ABOVE_MAX':
      return details.maxSelections ? `최대 ${details.maxSelections}폴더까지 베팅할 수 있습니다.` : '선택지 수가 최대 폴더수를 초과했습니다.';
    case 'SINGLE_MARKET_NOT_ALLOWED':
      return '해당 마켓은 단폴더 베팅이 허용되지 않습니다.';
    case 'COMBO_DISABLED':
      return '선택한 마켓 조합은 베팅할 수 없습니다.';
    case 'COMBO_MIN_ODDS':
      return '조합 가능한 최소 배당보다 낮은 선택지가 포함되어 있습니다.';
    case 'SAME_FIXTURE_NOT_ALLOWED':
      return '같은 경기 선택지는 조합할 수 없습니다.';
    case 'SAME_MARKET_NOT_ALLOWED':
      return '같은 경기의 같은 마켓 선택지는 조합할 수 없습니다.';
    case 'AXIS_BETTING_MIN_SELECTIONS':
      return details.minSelections ? `축베팅은 최소 ${details.minSelections}폴더부터 가능합니다.` : '축베팅 최소 폴더수를 충족하지 못했습니다.';
    case 'AXIS_BETTING_DISABLED':
      return '축베팅이 허용되지 않습니다.';
    case 'AXIS_BETTING_STAGE_LIMIT':
      return details.maxStage != null ? `축베팅은 최대 ${details.maxStage}단계까지 가능합니다.` : '축베팅 단계 한도를 초과했습니다.';
    case 'AXIS_BETTING_STAKE_LIMIT':
      return details.maxStake ? `축베팅 한도는 ${formatWon(details.maxStake)}입니다.` : '축베팅 금액 한도를 초과했습니다.';
    case 'MAX_ODDS_LIMIT':
      return details.maxOdds ? `최대 조합 배당은 ${formatOdds(details.maxOdds)}입니다.` : '최대 조합 배당을 초과했습니다.';
    case 'PAYOUT_LIMIT':
      return details.maxPayout ? `최대 당첨금액은 ${formatWon(details.maxPayout)}입니다.` : '최대 당첨금액을 초과했습니다.';
    case 'FIXTURE_EXPOSURE_LIMIT':
      return '해당 경기의 운영 한도를 초과했습니다.';
    case 'MARKET_EXPOSURE_LIMIT':
      return '해당 마켓의 운영 한도를 초과했습니다.';
    case 'WALLET_LEDGER_NOT_CONFIGURED':
      return '베팅 처리 시스템이 준비되지 않았습니다.';
    default:
      return '';
  }
};

export const getSportsnewBetErrorMessage = (source, fallback = '베팅할 수 없습니다. 선택지와 금액을 다시 확인해주세요.') => {
  const payload = pickPayload(source);
  const details = pickDetails(payload);
  const messageKo = pickMessageKo(payload);
  if (messageKo) return messageKo;

  const code = pickCode(payload);
  const mapped = messageForCode(code, details);
  if (mapped) return mapped;

  if (rawMessageAllowed(payload.message)) return payload.message;
  return fallback;
};
